import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { distinctUntilChanged, filter, map, startWith } from "rxjs/operators";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
  public menuItems: any[];
  breadcrumbs$: Observable<any[]>;
  header: string = "";
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.breadcrumbs$ = this.router.events.pipe(
      startWith(new NavigationEnd(0, "/", "/")),
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
      map((data) => this.buildBreadCrumb(this.activatedRoute.root))
    );
  }

  private buildBreadCrumb(
    route: ActivatedRoute,
    url: string = "",
    breadcrumbs: any[] = []
  ): any[] {
    let label = "",
      path = "/";
    const display = null;

    if (route.routeConfig) {
      if (route.routeConfig.data) {
        label = route.routeConfig.data.title;
        path += route.routeConfig.path;
        this.header = route.routeConfig.data.header;
      }
    } else {
      label = "";
      path += "";
    }

    const nextUrl = path && path !== "/" ? `${url}${path}` : url;
    const breadcrumb = {
      label,
      url: nextUrl,
    } as any;

    const newBreadcrumbs = label
      ? [...breadcrumbs, breadcrumb]
      : [...breadcrumbs];
    if (route.firstChild) {
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }
  sidenavCollapse() {
    $("body").toggleClass("sidenav-active");
  }
}
